import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Checkbox, message, Radio, Select, Alert } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Text3, Text4 } from '../../../../styles';
import { SmartCollectDisbursements } from '../../../../models';
import { printRupee } from '../../../../app_methods';
import { AccountCard } from './styles';
import { PROVIDER_PAYMENT_MODE_MESSAGES } from '../../../../constants';


let SettlementForm = (props) => {
    const [disabledFields, setDisabledFields] = useState({
        "NEFT": false,
        "IMPS": false,
        "RTGS": true
    });
    const [paymentModeOptions, setPaymentModeOptions] = useState([])
    const { form, settlementAccounts } = props;
    const { getFieldDecorator } = form;
    const validations = SmartCollectDisbursements.validations;

    useEffect(() => {
        setPaymentModeOptions(props.settlement_payment_modes);
    }, [paymentModeOptions]);
    
    const handleAmountChange = (e) => {
        const amount = parseFloat(e.target.value);
        if (isNaN(amount)) return;
        let _disabledFields = { ...disabledFields };
        _disabledFields["NEFT"] = amount < 1;
        _disabledFields["IMPS"] = amount < 1 || amount > 500000;
        _disabledFields["RTGS"] = amount < 200000;
        setDisabledFields(_disabledFields);
        if (props.form.getFieldValue("payment_mode") == "RTGS" && amount <= 500000) props.form.setFieldsValue({ payment_mode: "IMPS" });
        else if (props.form.getFieldValue("payment_mode") == "IMPS" && amount > 500000) props.form.setFieldsValue({ payment_mode: "RTGS" });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };

    const renderAccounts = () => {
        return (
            <Radio.Group className="w-100 mt-1">
                {
                    settlementAccounts.map((account, index) =>
                        account.is_active && <AccountCard className={`mr-1`}>
                            <div className="d-flex align-items-start">
                                <Radio id={`sa_${index}`} value={account.id}></Radio>
                                <label htmlFor={`sa_${index}`} style={{width: '-webkit-fill-available', marginRight: "20px"}}>
                                    <Text4 className="d-block" strong style={{ lineHeight: "20px", whiteSpace: "initial" }} ellipsis>{account.account_name}</Text4>
                                    <div className="d-flex align-items-start">
                                        <Text4 className="d-block" type="secondary">{account.account_number}</Text4>
                                        ・ <Text4 className="d-block" type="secondary">{account.account_ifsc}</Text4>
                                    </div>
                                </label>
                            </div>
                        </AccountCard>
                    )
                }
            </Radio.Group>
        )
    };

    const renderBasicForm = () => {
        return (
            <div>
                <div>
                    { props.virtualAccount ?
                        <Form.Item className="mb-4" label="Settle From">
                            {getFieldDecorator("custom_virtual_account_id", {
                                initialValue: props.virtualAccount.id
                            })(
                                <AccountCard className={`mr-1`}>
                                    <div className="d-flex align-items-start">
                                        <label style={{width: '-webkit-fill-available', marginRight: "20px"}}>
                                            <Text4 className="d-block" strong style={{ lineHeight: "20px", whiteSpace: "initial" }} ellipsis>{props.virtualAccount.label}</Text4>
                                                <div className="d-flex align-items-start">
                                                    <Text4 className="d-block" type="secondary">{props.virtualAccount.virtual_account_number}</Text4>
                                                    . <Text4 className="d-block" type="secondary">{props.virtualAccount.virtual_ifsc_number}</Text4>
                                                </div>
                                        </label>
                                    </div>
                                </AccountCard>
                            )}
                        </Form.Item>
                        : null}
                    
                    <Form.Item label="Amount">
                        {getFieldDecorator("amount", {
                            initialValue: props.virtualAccount ? (props.virtualAccount.usable_balance ? props.virtualAccount.usable_balance.toFixed(2).toString():0 ): 0,
                            rules: validations.amount
                        })(<Input autoComplete='off' onChange={handleAmountChange}/>)}
                    </Form.Item>
                    <Form.Item label="Payment Mode">
                        {getFieldDecorator("payment_mode", {
                            initialValue: paymentModeOptions[0],
                            rules: [{ required: true, message: "Please select payment mode." }]
                        })(
                            <Select>
                                {
                                    paymentModeOptions && paymentModeOptions.map(mode =>
                                        <Select.Option value={mode} disabled={disabledFields[mode]}>{mode}</Select.Option>
                                    )
                                }
                            </Select>
                        )}
                    </Form.Item>
                    {form.getFieldValue('payment_mode') === 'RTGS'?
                    <Alert
                        className="mb-2"
                        type="info"
                        message="Working hours for RTGS are 8:30 am to 5:45 pm. Any transaction after 5:45 pm would be processed on next working day."
                        icon={<Icon type="info-circle" />}
                        showIcon
                    /> : null
                    }
                    <Form.Item className="mt-2" label="Settlement Account">
                        {getFieldDecorator("settlement_account_id", {
                            rules: [{ required: true, message: "Please select settlement account." }],
                            initialValue: ((settlementAccounts || []).find(x => x.is_primary) || {}).id
                        })(renderAccounts())}
                    </Form.Item>
                </div>
            </div>
        )
    };

    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-sm">{renderBasicForm()}</div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Submit</Button>
            </div>
        </Form>
    )
};

SettlementForm = Form.create()(SettlementForm);
export { SettlementForm };